import { Component, forwardRef, OnInit } from '@angular/core';
import { ModelService } from '../../../../Services/model.service';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { UserActionBaseComponent } from '../userAction-base.component';
import { ApplyWawiMappingModel } from '../../../../Model/wawi/ApplyWawiMappingModel';
import { ExportParameter } from '../../../../Model/exportParameter/ExportParameter';
import { UpdateTemplateService } from '../../../../Services/updateTemplate.service';
import { CatalogService } from '../../../../Services/CatalogManagement/catalog.service';
import { TranslateService } from '@ngx-translate/core';
import { WawiListService } from '../../../../Services/wawiList.service';
import { TemplateItemTemplate } from '../../../../Model/Catalog/TemplateItemTemplate';
import { lastValueFrom } from 'rxjs';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';
import { SystemService } from 'app/Services/system.service';
import { parse } from 'acorn';

@Component({
  selector: 'userAction-applyWawiMappings',
  templateUrl: 'userAction-applyWawiMappings.component.html',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionApplyWawiMappings) }
  ]})
export class UserActionApplyWawiMappings extends UserActionBaseComponent implements OnInit {

  applyWawiMappingModel: ApplyWawiMappingModel;
  config: ExportParameter = new ExportParameter();
  fields: TemplateItemTemplate[] = [];
  fieldGroups: string[] = [];

  constructor(
    public updateTemplateService: UpdateTemplateService,
    public translate: TranslateService,
    public wawiListService: WawiListService,
    public loginService: LoginService, 
    public macroService: MacroService, 
    public jobService: JobService, 
    public catalogService: CatalogService,
    public systemService:SystemService,
  ) {
    super(loginService, macroService);
    this.applyWawiMappingModel = new ApplyWawiMappingModel();
  }

  async ngOnInit() {
    this.fields = await lastValueFrom(
      this.wawiListService.getWawiMappingFields(this.loginService.currentUser.customerId)
    );
    this.fieldGroups = this.updateTemplateService.GetFieldGroups();
  }

  async canStartMacro() : Promise<boolean> {
    if (
      !this.config.fieldsToMappingIds ||
      Object.keys(this.config.fieldsToMappingIds).length == 0 ||
      Object.values(this.config.fieldsToMappingIds).every((x) => x == '')
    ) {
      this.systemService.notifyInfo(
        this.translate.instant('mindestens ein Feld markieren und das Mapping ausfüllen')
      );
      return false;
    }
    return true;
  }

  createParameterStringAsJsonString() {
    this.applyWawiMappingModel.fieldToMappingId = this.config.fieldsToMappingIds;
    return JSON.stringify(this.applyWawiMappingModel);
  }

  public parseParameter(parameter: string) {
    if(!parameter)
      return;

    try {
      const parsed = JSON.parse(parameter);
      if (parsed) {
        this.applyWawiMappingModel = parsed;
        this.config = {
          ...this.config,
          fieldsToMappingIds: parsed.fieldToMappingId
        } as ExportParameter;

      }
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
